// German catalogue for RegisterPage — one entry for every key the page wraps.
// Keys ARE the English strings (see src/shared/i18n.ts); {placeholders} stay identical.
import { registerDe } from '../i18n/index.js';

registerDe({
  // ── vocabularies: types, weights, statuses (label maps wrapped at render sites) ──
  'Functional': 'Funktional',
  'Non-functional': 'Nicht-funktional',
  'Constraint': 'Rahmenbedingung',
  'Assumption': 'Annahme',
  'Exclusion': 'Ausschluss',
  'functional': 'funktional',
  'non-functional': 'nicht-funktional',
  'constraint': 'Rahmenbedingung',
  'assumption': 'Annahme',
  'exclusion': 'Ausschluss',
  'Must': 'Muss',
  'Should': 'Soll',
  'Could': 'Kann',
  "Won't": 'Nicht',
  'must': 'Muss',
  'should': 'Soll',
  'could': 'Kann',
  "won't": 'Nicht',
  'Draft': 'Entwurf',
  'Confirmed': 'Bestätigt',
  'Baselined': 'In der Baseline',
  'Changed': 'Geändert',
  'Delivered': 'Geliefert',
  'Accepted': 'Abgenommen',
  'Out of scope': 'Ausserhalb des Umfangs',
  'Planned': 'Geplant',
  'In progress': 'In Arbeit',
  'Ready': 'Bereit',
  'Dropped': 'Verworfen',
  'draft': 'Entwurf',
  'confirmed': 'bestätigt',
  'baselined': 'in der Baseline',
  'changed': 'geändert',
  'delivered': 'geliefert',
  'accepted': 'abgenommen',
  'out of scope': 'ausserhalb des Umfangs',
  'planned': 'geplant',
  'in progress': 'in Arbeit',
  'ready': 'bereit',
  'dropped': 'verworfen',
  'proposed': 'vorgeschlagen',

  // ── the five ledger cells and the tabs ──
  'SCOPE': 'UMFANG',
  'HELD': 'GEHALTEN',
  'FUNDED': 'FINANZIERT',
  'PROVEN': 'NACHGEWIESEN',
  'SOURCED': 'BELEGT',
  'Client call': 'Kundengespräch',

  // ── the flow-ownership tooltips on the read-only status chip ──
  'Set by the baseline machinery when the SOW is signed — altered only through a change request.':
    'Von der Baseline-Maschinerie gesetzt, wenn die Leistungsbeschreibung (SOW) unterzeichnet wird — geändert nur durch einen Änderungsantrag.',
  'Set when a change request is approved.': 'Gesetzt, wenn ein Änderungsantrag genehmigt wird.',
  'Set by descope (pre-baseline) or an approved change request.':
    'Gesetzt durch Aus-dem-Umfang-Nehmen (vor der Baseline) oder einen genehmigten Änderungsantrag.',
  'Set by the delivery flow on the Acceptance page.': 'Vom Lieferablauf auf der Abnahme-Seite gesetzt.',
  'Set by the acceptance flow when the client signs off.': 'Vom Abnahmeablauf gesetzt, wenn der Kunde abnimmt.',

  // ── deletable entities and the retire-instead hints ──
  'requirement': 'Anforderung',
  'deliverable': 'Arbeitsergebnis',
  'acceptance criterion': 'Abnahmekriterium',
  'test case': 'Testfall',
  'Mark out of scope keeps the requirement with every revision and every piece of evidence.':
    '«Als ausserhalb des Umfangs markieren» behält die Anforderung mit jeder Revision und jedem Beleg.',
  'Setting the status to Dropped keeps the deliverable and its mappings.':
    'Der Status «Verworfen» behält das Arbeitsergebnis und seine Zuordnungen.',
  'Setting the criterion to dropped keeps it and its test-case links.':
    'Das Kriterium auf «verworfen» zu setzen behält es und seine Testfall-Verknüpfungen.',
  'Setting the test case to Dropped keeps it and any runs the client recorded.':
    'Den Testfall auf «Verworfen» zu setzen behält ihn und alle Läufe, die der Kunde erfasst hat.',

  // ── field words (the "{ref} {field} set to {label}" toast) ──
  'priority': 'Gewicht',
  'type': 'Typ',
  'status': 'Status',
  'category': 'Kategorie',

  // ── revision sources (source.replace('_', ' ')) and CR statuses ──
  'manual': 'manuell',
  'extraction': 'Extraktion',
  'change request': 'Änderungsantrag',
  'merge': 'Zusammenführung',
  'split': 'Aufteilung',
  'submitted': 'eingereicht',
  'approved': 'genehmigt',
  'rejected': 'abgelehnt',
  'deferred': 'zurückgestellt',
  'withdrawn': 'zurückgezogen',

  // ── open-question words ──
  'open': 'offen',
  'settled': 'entschieden',
  'answered': 'beantwortet',
  'refused': 'abgelehnt',
  'agent': 'Agent',
  'operator': 'Operator',
  'portal': 'Portal',

  // ── literal keys, in source order of the extracted inventory ──
  ' · filtered': ' · gefiltert',
  '— no milestone —': '— kein Meilenstein —',
  '— no tag on any row': '— kein Tag auf irgendeiner Zeile',
  '— none defined yet —': '— noch keine definiert —',
  '— not defined': '— nicht definiert',
  '— position {side} is what it already says, so the other side is the one that would change it.':
    '— Position {side} entspricht dem, was bereits dasteht; die andere Seite wäre die, die es ändern würde.',
  '— the register itself': '— das Register selbst',
  '— the row on the register today': '— die Zeile, wie sie heute im Register steht',
  ', {n} already carried it': ', {n} trugen es bereits',
  '{deleted} deleted, {refused} refused — see the list': '{deleted} gelöscht, {refused} abgelehnt — siehe Liste',
  '{done} held, {refused} refused — {ref}: {reason}': '{done} übernommen, {refused} abgelehnt — {ref}: {reason}',
  '{done} tagged, {refused} refused — {reason} · {cost}': '{done} getaggt, {refused} abgelehnt — {reason} · {cost}',
  '{drafts} still proposed ◇': '{drafts} noch vorgeschlagen ◇',
  '{drafts} still proposed ◇ · {talking} in discussion': '{drafts} noch vorgeschlagen ◇ · {talking} in Diskussion',
  '{i} of {n} {bucket}': '{i} von {n} {bucket}',
  '{musts} must · {exclusions} · {descoped} descoped': '{musts} Muss · {exclusions} · {descoped} aus dem Umfang genommen',
  '{n} cannot say why they say this (P2)': '{n} können nicht sagen, warum sie das sagen (P2)',
  '{n} not visible to the client': '{n} für den Kunden nicht sichtbar',
  '{n} set to {status}, {skipped} skipped': '{n} auf {status} gesetzt, {skipped} übersprungen',
  '{n} unfunded — blocks the estimate': '{n} nicht finanziert — blockiert die Schätzung',
  '{ref} — span in context': '{ref} — Quellenstelle im Kontext',
  '{ref} (draft)': '{ref} (Entwurf)',
  '{ref} {field} set to {label}': '{ref}: {field} auf {label} gesetzt',
  '{ref} amended → rev {n} — {stamp}': '{ref} angepasst → Rev. {n} — {stamp}',
  '{ref} cannot answer “why does it say this?”': '{ref} kann die Frage «warum steht das hier?» nicht beantworten',
  '{ref} cannot be deleted': '{ref} kann nicht gelöscht werden',
  '{ref} cites nothing — it cannot answer "why does it say this?"':
    '{ref} zitiert nichts — es kann die Frage «warum steht das hier?» nicht beantworten',
  '{ref} confirmed': '{ref} bestätigt',
  '{ref} confirmed — {stamp}': '{ref} bestätigt — {stamp}',
  '{ref} created': '{ref} erstellt',
  '{ref} created — linter flagged it': '{ref} erstellt — der Linter hat es markiert',
  '{ref} deleted': '{ref} gelöscht',
  '{ref} detached from its milestone': '{ref} vom Meilenstein gelöst',
  '{ref} goes out of scope and the refusal is recorded, stamped “{stamp}”':
    '{ref} geht aus dem Umfang, und die Ablehnung wird protokolliert, gestempelt «{stamp}»',
  '{ref} is {status}': '{ref} ist {status}',
  '{ref} is {status} and belongs to a signed baseline — raise a change request to alter it.':
    '{ref} ist {status} und gehört zu einer unterzeichneten Baseline — stellen Sie einen Änderungsantrag, um es zu ändern.',
  '{ref} is back in scope as proposed — confirm it once it is agreed':
    '{ref} ist als vorgeschlagen zurück im Umfang — bestätigen Sie es, sobald es vereinbart ist',
  '{ref} is cited without a stored span — open the row for the full record.':
    '{ref} wird ohne gespeicherte Quellenstelle zitiert — öffnen Sie die Zeile für den vollständigen Eintrag.',
  '{ref} is held — click to change that': '{ref} ist übernommen — klicken Sie, um das zu ändern',
  '{ref} is not in this register — it may have been merged away or deleted.':
    '{ref} ist nicht in diesem Register — es wurde möglicherweise zusammengeführt oder gelöscht.',
  '{ref} is not in this register — nothing on this page carries that ref.':
    '{ref} ist nicht in diesem Register — nichts auf dieser Seite trägt diese Referenz.',
  '{ref} is out of scope': '{ref} ist ausserhalb des Umfangs',
  '{ref} is out of scope — click to change that': '{ref} ist ausserhalb des Umfangs — klicken Sie, um das zu ändern',
  '{ref} is proposed again — confirm it once the client has agreed':
    '{ref} ist wieder vorgeschlagen — bestätigen Sie es, sobald der Kunde zugestimmt hat',
  '{ref} is waiting on the call — decide it there, or confirm it here regardless':
    '{ref} wartet auf das Kundengespräch — entscheiden Sie es dort, oder bestätigen Sie es dennoch hier',
  '{ref} moved to that milestone': '{ref} zu diesem Meilenstein verschoben',
  '{ref} now at rev {n}': '{ref} jetzt bei Rev. {n}',
  '{ref} refused': '{ref} abgelehnt',
  '{ref} refused — {row} out of scope': '{ref} abgelehnt — {row} ausserhalb des Umfangs',
  '{ref} rev {n}': '{ref} Rev. {n}',
  '{ref} split into {parts}': '{ref} aufgeteilt in {parts}',
  '{ref} stands as written — confirms it and settles the question, stamped “{stamp}”':
    '{ref} bleibt wie geschrieben — bestätigt es und entscheidet die Frage, gestempelt «{stamp}»',
  '{ref} tags updated': '{ref}: Tags aktualisiert',
  '{ref}’s evidence is carried onto the target as a superseding revision, and {ref} is marked out of scope. Nothing is deleted.':
    'Die Belege von {ref} werden als ablösende Revision auf das Ziel übertragen, und {ref} wird als ausserhalb des Umfangs markiert. Nichts wird gelöscht.',
  '{source} merged into {target}': '{source} zusammengeführt in {target}',
  '{subject} is held — an operator stands behind it as scope.':
    '{subject} ist gehalten — ein Operator steht als Umfang dahinter.',
  '{subject} is proposed — nobody has confirmed it yet.':
    '{subject} ist vorgeschlagen — niemand hat es bisher bestätigt.',
  '{updated} updated, {refused} refused — {ref} {reason}': '{updated} aktualisiert, {refused} abgelehnt — {ref} {reason}',
  'a new revision, confirms it, and settles this question — stamped “{stamp}”.':
    'eine neue Revision, bestätigt es und entscheidet diese Frage — gestempelt «{stamp}».',
  'a new revision. The losing side stays on the record, in the revision it replaces.':
    'eine neue Revision. Die unterlegene Seite bleibt aktenkundig, in der Revision, die sie ablöst.',
  'A pointer, never the data itself': 'Ein Verweis, nie die Daten selbst',
  'A register belongs to one engagement. Pick one from the switcher to open its requirements.':
    'Ein Register gehört zu genau einem Auftrag. Wählen Sie einen im Umschalter, um seine Anforderungen zu öffnen.',
  'A register is built two ways: the agent proposes from the documents already ingested, or you write the first requirement by hand. Neither is undone — a rejected proposal keeps its reason.':
    'Ein Register entsteht auf zwei Wegen: Der Agent schlägt aus den bereits eingelesenen Dokumenten vor, oder Sie schreiben die erste Anforderung von Hand. Keiner der beiden Wege wird rückgängig gemacht — ein abgelehnter Vorschlag behält seine Begründung.',
  'A test case attaches to a criterion — there is none yet': 'Ein Testfall hängt an einem Kriterium — es gibt noch keines',
  'A test case attaches to a criterion, and there is none yet.': 'Ein Testfall hängt an einem Kriterium, und es gibt noch keines.',
  'acceptance criteria are unproven. A test case is what turns a criterion into something the client can pass or fail at UAT.':
    'Abnahmekriterien sind nicht nachgewiesen. Erst ein Testfall macht aus einem Kriterium etwas, das der Kunde in der UAT bestehen oder durchfallen lassen kann.',
  'Acceptance criteria covered': 'Abnahmekriterien abgedeckt',
  'ACs': 'AK',
  'Action': 'Aktion',
  'Add acceptance criterion': 'Abnahmekriterium hinzufügen',
  'Add criterion': 'Kriterium hinzufügen',
  'Add evidence': 'Beleg hinzufügen',
  'Add one tag to every selected row': 'Ein Tag zu jeder ausgewählten Zeile hinzufügen',
  'Add part': 'Teil hinzufügen',
  'Add step': 'Schritt hinzufügen',
  'Add tag': 'Tag hinzufügen',
  'Add tag…': 'Tag hinzufügen…',
  'Add the typed tag': 'Das eingetippte Tag hinzufügen',
  'add your own tag…': 'eigenes Tag hinzufügen…',
  'All': 'Alle',
  'All categories ({n})': 'Alle Kategorien ({n})',
  'All rows': 'Alle Zeilen',
  'Already in the pool.': 'Bereits im Pool.',
  'Amend, then confirm': 'Anpassen, dann bestätigen',
  'and it drops out of the default register view. Nothing is deleted (P4).':
    'und es fällt aus der Standardansicht des Registers. Nichts wird gelöscht (P4).',
  'answered: “{error}”.': 'antwortete: «{error}».',
  'asked by the client': 'vom Kunden gefragt',
  'Back to draft': 'Zurück zum Entwurf',
  'Back to proposed ◇': 'Zurück zu vorgeschlagen ◇',
  'Back to proposed ◇ — ask the client first': 'Zurück zu vorgeschlagen ◇ — fragen Sie zuerst den Kunden',
  'background': 'Hintergrund',
  'baselined · signed': 'in der Baseline · unterzeichnet',
  'Bring it back as proposed ◇ — it is confirmed again like any other row':
    'Als vorgeschlagen ◇ zurückholen — bestätigt wird es wieder wie jede andere Zeile',
  'Call on {date}': 'Gespräch am {date}',
  'Cancel': 'Abbrechen',
  'Cannot be confirmed: it cites no evidence (P2). Revise it with a quoted span first.':
    'Kann nicht bestätigt werden: Es zitiert keinen Beleg (P2). Revidieren Sie es zuerst mit einer zitierten Quellenstelle.',
  'Category': 'Kategorie',
  'Category of {ref}': 'Kategorie von {ref}',
  'Change requests': 'Änderungsanträge',
  'Change the (universal) category': 'Die (universelle) Kategorie ändern',
  'Change the requirement type': 'Den Anforderungstyp ändern',
  'Change the weight — MoSCoW is editable until the baseline locks it':
    'Das Gewicht ändern — MoSCoW ist editierbar, bis die Baseline es sperrt',
  'chars {start}–{end}': 'Zeichen {start}–{end}',
  'Classification': 'Klassifikation',
  'Clear': 'Zurücksetzen',
  'Clear every filter': 'Alle Filter zurücksetzen',
  'Clear pool': 'Pool leeren',
  'Close': 'Schliessen',
  'confirm': 'bestätigen',
  'Confirm': 'Bestätigen',
  'Confirm — stand behind it': 'Bestätigen — dahinterstehen',
  'Confirm {ref} — stand behind it as real scope': '{ref} bestätigen — als echten Umfang dahinterstehen',
  'Confirmed — as it stands': 'Bestätigt — wie es steht',
  'Confirming it is refused (P2).': 'Die Bestätigung wird abgelehnt (P2).',
  'Cover': 'Abdeckung',
  'Coverage did not answer.': 'Die Abdeckung hat nicht geantwortet.',
  'Covers': 'Deckt ab',
  'Covers acceptance criteria': 'Deckt Abnahmekriterien ab',
  'Create': 'Erstellen',
  'Create requirement': 'Anforderung erstellen',
  'Create test case': 'Testfall erstellen',
  'Create the draft row': 'Die Entwurfszeile erstellen',
  'Criteria': 'Kriterien',
  'current': 'aktuell',
  'D A T': 'L A T',
  'Decide an open question on the call and it lands here with its stamp.':
    'Entscheiden Sie eine offene Frage im Gespräch, und sie landet hier mit ihrem Stempel.',
  'Definition of done': 'Abnahmekriterien',
  'Delete {n} permanently': '{n} endgültig löschen',
  'Delete {noun}': '{noun} löschen',
  'Delete {ref}': '{ref} löschen',
  'Delete {ref}?': '{ref} löschen?',
  'Delete finished': 'Löschen abgeschlossen',
  'Delete is for a mistake — a duplicate, a typo, a row that should never have existed.':
    'Löschen ist für Fehler — ein Duplikat, ein Tippfehler, eine Zeile, die nie hätte existieren dürfen.',
  'Delete permanently…': 'Endgültig löschen…',
  'Deleted': 'Gelöscht',
  'Deleting…': 'Wird gelöscht…',
  'Deliverable': 'Arbeitsergebnis',
  'Deliverable created': 'Arbeitsergebnis erstellt',
  'Deliverable linked': 'Arbeitsergebnis verknüpft',
  'Deliverable unlinked': 'Arbeitsergebnis-Verknüpfung gelöst',
  'deliverables': 'Arbeitsergebnisse',
  'Deliverables': 'Arbeitsergebnisse',
  'Deliverables turn requirements into funded work. Every must-have needs one before G2.':
    'Arbeitsergebnisse machen aus Anforderungen finanzierte Arbeit. Jedes Muss braucht eines vor G2.',
  'derived, not stored': 'abgeleitet, nicht gespeichert',
  'descoped': 'aus dem Umfang genommen',
  'Descoped rows — kept with every revision and every piece of evidence (P4)':
    'Aus dem Umfang genommene Zeilen — behalten mit jeder Revision und jedem Beleg (P4)',
  'Description': 'Beschreibung',
  'Do this…': 'Tun Sie dies…',
  'Document list unavailable ({error}). The requirement can be created without evidence and cited later.':
    'Dokumentliste nicht verfügbar ({error}). Die Anforderung kann ohne Beleg erstellt und später zitiert werden.',
  'Draft ↔ held — baselined, changed, out-of-scope, delivered and accepted are set by their own flows':
    'Entwurf ↔ übernommen — in der Baseline, geändert, ausserhalb des Umfangs, geliefert und abgenommen werden von ihren eigenen Abläufen gesetzt',
  'Drop': 'Verwerfen',
  'e.g. data-residency': 'z. B. data-residency',
  'Each part becomes a new requirement with its own REQ ref, inheriting {ref}’s evidence, type, priority and category. {ref} is marked out of scope with the split recorded.':
    'Jeder Teil wird eine neue Anforderung mit eigener REQ-Referenz und erbt Belege, Typ, Gewicht und Kategorie von {ref}. {ref} wird als ausserhalb des Umfangs markiert, die Aufteilung wird protokolliert.',
  'Every acceptance criterion needs at least one test case before G3.':
    'Jedes Abnahmekriterium braucht mindestens einen Testfall vor G3.',
  'Every chip above carries the count it would leave you with, so this state is unreachable by clicking. It is reachable by typing: the search runs on the server and cannot be predicted here.':
    'Jeder Chip oben trägt die Anzahl, die er übrig liesse — durch Klicken ist dieser Zustand also unerreichbar. Durch Tippen schon: Die Suche läuft auf dem Server und lässt sich hier nicht vorhersagen.',
  'Every chip carries its own count, so this should not have been reachable — the rows may have changed under the filter since it was set.':
    'Jeder Chip trägt seine eigene Anzahl — das hätte nicht erreichbar sein sollen. Die Zeilen haben sich unter dem Filter möglicherweise geändert, seit er gesetzt wurde.',
  'every condition this page could compute is met — {list} could not be computed':
    'jede Bedingung, die diese Seite berechnen konnte, ist erfüllt — {list} konnte nicht berechnet werden',
  'every criterion has a test case': 'jedes Kriterium hat einen Testfall',
  'every criterion is testable': 'jedes Kriterium ist testbar',
  'Every decision is recorded with this reference — name the call once, e.g. “Call with Mrs Meier · 23.08.2026”':
    'Jede Entscheidung wird mit dieser Referenz protokolliert — benennen Sie das Gespräch einmal, z. B. «Gespräch mit Frau Meier · 23.08.2026»',
  'every must maps to a deliverable': 'jedes Muss ist einem Arbeitsergebnis zugeordnet',
  'every requirement held, funded, proven and sourced': 'jede Anforderung gehalten, finanziert, nachgewiesen und belegt',
  'every row cites a document': 'jede Zeile zitiert ein Dokument',
  'every row stands behind an operator': 'hinter jeder Zeile steht ein Operator',
  'Every row, descoped included': 'Alle Zeilen, einschliesslich der aus dem Umfang genommenen',
  'Every selected row already carries {tag}. Nothing was written.':
    'Jede ausgewählte Zeile trägt {tag} bereits. Nichts wurde geschrieben.',
  'Evid': 'Beleg',
  'evidence': 'Belege',
  'Evidence': 'Belege',
  'Evidence — verbatim spans (P2)': 'Belege — wörtliche Quellenstellen (P2)',
  'Exclusions': 'Ausschlüsse',
  'Expected': 'Erwartet',
  'Export ▾': 'Export ▾',
  'Filter by (universal) category': 'Nach (universeller) Kategorie filtern',
  'Filter requirements…': 'Anforderungen filtern…',
  'Find the target requirement…': 'Zielanforderung finden…',
  'Free-text operator tag — not restricted to the pool. Enter saves.':
    'Freitext-Operator-Tag — nicht auf den Pool beschränkt. Enter speichert.',
  'funded by {list}': 'finanziert durch {list}',
  'Given …, when …, then … (include a measurable threshold)':
    'Gegeben …, wenn …, dann … (mit messbarem Schwellenwert)',
  'Hinges on': 'Hängt ab von',
  'History': 'Verlauf',
  'Hold a claim “· and put to the client”, or let the agent flag a question, and it lands here for the next call.':
    'Übernehmen Sie eine Aussage «· und dem Kunden vorlegen», oder lassen Sie den Agenten eine Frage markieren — sie landet hier für das nächste Gespräch.',
  'Hold all {n}': 'Alle {n} übernehmen',
  'Hold all {n} proposed criteria — an operator stands behind them as what the client will be held to':
    'Alle {n} vorgeschlagenen Kriterien übernehmen — ein Operator steht dahinter als das, woran der Kunde gemessen wird',
  'in discussion': 'in Diskussion',
  'In discussion': 'In Diskussion',
  'in play': 'im Spiel',
  'Include the descoped': 'Aus dem Umfang genommene einbeziehen',
  'It': 'Eintrag',
  'Lint clean': 'Lint sauber',
  'List': 'Liste',
  'Listed in the client’s UAT view.': 'In der UAT-Ansicht des Kunden aufgeführt.',
  'Map': 'Zuordnen',
  'Map the selected requirements to a deliverable': 'Die ausgewählten Anforderungen einem Arbeitsergebnis zuordnen',
  'Map to a deliverable…': 'Einem Arbeitsergebnis zuordnen…',
  'Map to deliverable…': 'Arbeitsergebnis zuordnen…',
  'Mapped requirements': 'Zugeordnete Anforderungen',
  'Mark {ref} out of scope?': '{ref} als ausserhalb des Umfangs markieren?',
  'Mark out of scope': 'Als ausserhalb des Umfangs markieren',
  'Mark out of scope…': 'Als ausserhalb des Umfangs markieren…',
  'Mark ready': 'Als bereit markieren',
  'Measured by:': 'Gemessen durch:',
  'Measurement method (required for non-functional)': 'Messmethode (erforderlich für nicht-funktionale)',
  'Merge — {ref} becomes out of scope': 'Zusammenführen — {ref} geht aus dem Umfang',
  'Merge {ref} into…': '{ref} zusammenführen in…',
  'Merge into…': 'Zusammenführen in…',
  'merged → {ref}': 'zusammengeführt → {ref}',
  'Merged — its content lives on in {ref}, where the evidence was carried over.':
    'Zusammengeführt — der Inhalt lebt in {ref} weiter, wohin die Belege übertragen wurden.',
  'merged into {ref} →': 'zusammengeführt in {ref} →',
  'Merged statement (the target’s new revision)': 'Zusammengeführte Aussage (die neue Revision des Ziels)',
  'Milestone': 'Meilenstein',
  'More ▾': 'Mehr ▾',
  'Name': 'Name',
  'Neither side yet — it stays on the client-call agenda, and nothing is written.':
    'Noch keine der beiden Seiten — es bleibt auf der Agenda des Kundengesprächs, und nichts wird geschrieben.',
  'New deliverable': 'Neues Arbeitsergebnis',
  'New requirement': 'Neue Anforderung',
  'New test case': 'Neuer Testfall',
  'No AC linked': 'Kein AK verknüpft',
  'No acceptance criteria yet.': 'Noch keine Abnahmekriterien.',
  'no acceptance criterion — nothing to test against': 'kein Abnahmekriterium — nichts, wogegen getestet werden kann',
  'no acceptance criterion on record': 'kein Abnahmekriterium aktenkundig',
  'No criterion': 'Kein Kriterium',
  'No deliverable': 'Kein Arbeitsergebnis',
  'no deliverable — unfunded work': 'kein Arbeitsergebnis — nicht finanzierte Arbeit',
  'No deliverable to map to yet': 'Noch kein Arbeitsergebnis zum Zuordnen',
  'No deliverables yet': 'Noch keine Arbeitsergebnisse',
  'No eligible target.': 'Kein geeignetes Ziel.',
  'No engagement selected': 'Kein Auftrag ausgewählt',
  'No engagement selected.': 'Kein Auftrag ausgewählt.',
  'No evidence': 'Keine Belege',
  'No milestones yet — define them on Contracting → Payment schedule':
    'Noch keine Meilensteine — definieren Sie sie unter Vertrag → Zahlungsplan',
  'no MUST requirement on record': 'keine MUSS-Anforderung aktenkundig',
  'No requirement — unjustified work (blocks G2)': 'Keine Anforderung — unbegründete Arbeit (blockiert G2)',
  'No requirement matches that filter.': 'Keine Anforderung entspricht diesem Filter.',
  'no response': 'keine Antwort',
  'no row fits — this side becomes a new draft requirement (functional · should)':
    'keine Zeile passt — diese Seite wird eine neue Entwurfsanforderung (funktional · Soll)',
  'No row matches': 'Keine Zeile passt',
  'No row on the register carries this claim, so it enters as a new DRAFT requirement (functional · should). It will cite no evidence, so confirming it is refused until you revise it with a span.':
    'Keine Zeile im Register trägt diese Aussage, also kommt sie als neue ENTWURFS-Anforderung herein (funktional · Soll). Sie zitiert keinen Beleg, die Bestätigung wird also abgelehnt, bis Sie sie mit einer Quellenstelle revidieren.',
  'No tag exists yet — set the pool first': 'Noch kein Tag vorhanden — setzen Sie zuerst den Pool',
  'No tags — the agent will propose none.': 'Keine Tags — der Agent wird keine vorschlagen.',
  'No test case': 'Kein Testfall',
  'no test case — the client has nothing to run at UAT':
    'kein Testfall — der Kunde hat nichts, das er in der UAT ausführen kann',
  'No test case exists in {code}': 'In {code} existiert kein Testfall',
  'No test cases': 'Keine Testfälle',
  'none': 'keine',
  'None linked.': 'Keine verknüpft.',
  'not applicable': 'nicht anwendbar',
  'not applicable — an exclusion funds nothing': 'nicht anwendbar — ein Ausschluss finanziert nichts',
  'not applicable to an exclusion': 'auf einen Ausschluss nicht anwendbar',
  'Not defined.': 'Nicht definiert.',
  'Not visible to the client until it is ready.': 'Für den Kunden nicht sichtbar, bis es bereit ist.',
  'nothing {bucket}': 'nichts {bucket}',
  'Nothing else points at it.': 'Nichts anderes verweist darauf.',
  'nothing here is testable yet': 'hier ist noch nichts testbar',
  'Nothing in this selection can be deleted.': 'Nichts in dieser Auswahl kann gelöscht werden.',
  'Nothing is cited on the current revision —': 'Auf der aktuellen Revision ist nichts zitiert —',
  'Nothing is on record for {code}': 'Für {code} ist nichts aktenkundig',
  'Nothing is outstanding': 'Nichts ist ausstehend',
  'nothing on record yet': 'noch nichts aktenkundig',
  'nothing open — the agenda is clear': 'nichts offen — die Agenda ist leer',
  'nothing settled yet': 'noch nichts entschieden',
  'Nothing settled yet.': 'Noch nichts entschieden.',
  'Nothing that could be checked is outstanding': 'Nichts Prüfbares ist ausstehend',
  'Obligations': 'Verpflichtungen',
  'Observe that…': 'Beobachten, dass…',
  'of': 'von',
  'of {n}': 'von {n}',
  'of {n} criteria': 'von {n} Kriterien',
  'of {n} must': 'von {n} Muss',
  'On the client-call agenda — open the call at this question':
    'Auf der Agenda des Kundengesprächs — das Gespräch bei dieser Frage öffnen',
  'Only rows citing': 'Nur Zeilen mit Zitat aus',
  'Only rows tagged {tag}': 'Nur Zeilen mit Tag {tag}',
  'Open {ref}': '{ref} öffnen',
  'Open {ref} →': '{ref} öffnen →',
  'Open {ref} at its evidence': '{ref} bei seinen Belegen öffnen',
  'Open the row': 'Zeile öffnen',
  'Open the row — revise, merge, split': 'Zeile öffnen — revidieren, zusammenführen, aufteilen',
  'Opposes': 'Widerspricht',
  '…or none fits — make it a new row': '…oder keine passt — machen Sie eine neue Zeile daraus',
  'out of scope — CR only': 'ausserhalb des Umfangs — nur per Änderungsantrag',
  'Overall expected result': 'Erwartetes Gesamtergebnis',
  'Part {n}': 'Teil {n}',
  'Paste the exact sentence from the document — it is validated as a literal substring.':
    'Fügen Sie den exakten Satz aus dem Dokument ein — er wird als wörtliche Teilzeichenkette validiert.',
  'Pick from the scheme…': 'Aus dem Schema wählen…',
  'Position {side}': 'Position {side}',
  'Position {side} wins →': 'Position {side} gewinnt →',
  'Position {side} wins — {ref}': 'Position {side} gewinnt — {ref}',
  'Preconditions': 'Vorbedingungen',
  'Priority': 'Priorität',
  'proposal #{id}': 'Vorschlag #{id}',
  'Proposed ◇': 'Vorgeschlagen ◇',
  'question': 'Frage',
  'Question': 'Frage',
  'Question dropped': 'Frage verworfen',
  'Raise a change request →': 'Änderungsantrag stellen →',
  'Raised by the agent — nobody has answered it': 'Vom Agenten gestellt — niemand hat sie beantwortet',
  'raised by the operator': 'vom Operator gestellt',
  'rather than printing a confident zero.': 'statt selbstsicher eine Null auszuweisen.',
  'Rationale': 'Begründung',
  'ready for the client': 'bereit für den Kunden',
  'Record resolution': 'Entscheid festhalten',
  'Record something else →': 'Etwas anderes festhalten →',
  'Record the answer →': 'Die Antwort festhalten →',
  'Record what was decided or done — stamped “{stamp}”':
    'Festhalten, was entschieden oder getan wurde — gestempelt «{stamp}»',
  'Ref': 'Ref',
  'Refine this requirement with the client': 'Diese Anforderung mit dem Kunden verfeinern',
  'Refused': 'Abgelehnt',
  'Refused — out of scope': 'Abgelehnt — ausserhalb des Umfangs',
  'Register CSV': 'Register-CSV',
  'Remove {tag} from {ref}': '{tag} von {ref} entfernen',
  'Remove {tag} from the pool': '{tag} aus dem Pool entfernen',
  'Remove evidence row': 'Belegzeile entfernen',
  'Remove part': 'Teil entfernen',
  'Remove step': 'Schritt entfernen',
  'Remove tag {tag}': 'Tag {tag} entfernen',
  'Remove the pool — the agent proposes no tags at all': 'Den Pool entfernen — der Agent schlägt gar keine Tags vor',
  'Requirement': 'Anforderung',
  'Requirements': 'Anforderungen',
  'Requirements register': 'Anforderungsregister',
  'Requirements this funds': 'Anforderungen, die dies finanziert',
  'Resolution recorded — the agent reads it as a client decision on its next run':
    'Entscheid festgehalten — der Agent liest ihn beim nächsten Lauf als Kundenentscheidung',
  'Restore to scope — proposed ◇': 'In den Umfang zurückholen — vorgeschlagen ◇',
  'rev {n}': 'Rev. {n}',
  'Revise → new revision': 'Revidieren → neue Revision',
  'Revise → rev {n}': 'Revidieren → Rev. {n}',
  'Revise {ref} → rev {n}': '{ref} revidieren → Rev. {n}',
  'revises {ref} with this side · the losing side stays on the record':
    'revidiert {ref} mit dieser Seite · die unterlegene Seite bleibt aktenkundig',
  'Roadmap': 'Roadmap',
  'Rows carrying at least one criterion with no test case. PROVEN above counts CRITERIA, not rows — different units, both labelled.':
    'Zeilen mit mindestens einem Kriterium ohne Testfall. NACHGEWIESEN oben zählt KRITERIEN, nicht Zeilen — verschiedene Einheiten, beide beschriftet.',
  'Rows in play only — the descoped are hidden, because that is the qualifier the gate tally you arrived from carries.':
    'Nur Zeilen im Spiel — die aus dem Umfang genommenen sind ausgeblendet, denn das ist der Zusatz, den die Gate-Zählung trägt, von der Sie gekommen sind.',
  'Rows named by an OPEN question on the client call — decide them on the call, then confirm':
    'Zeilen, die eine OFFENE Frage im Kundengespräch benennt — entscheiden Sie sie im Gespräch, dann bestätigen',
  'Rows nobody has stood behind yet': 'Zeilen, hinter die sich noch niemand gestellt hat',
  'rows shown': 'Zeilen angezeigt',
  'Rows weighted {weight}, including any that are out of scope. The SCOPE cell counts only rows in play.':
    'Zeilen mit Gewicht {weight}, einschliesslich der ausserhalb des Umfangs. Die Zelle UMFANG zählt nur Zeilen im Spiel.',
  'Rows with no acceptance criterion — nothing to test them against':
    'Zeilen ohne Abnahmekriterium — nichts, wogegen sie getestet werden können',
  'Save mapping ({n})': 'Zuordnung speichern ({n})',
  'Save pool': 'Pool speichern',
  'Save revision': 'Revision speichern',
  'Search statements…': 'Aussagen durchsuchen…',
  'searching the statements…': 'Aussagen werden durchsucht…',
  'Select all': 'Alle auswählen',
  'Select document…': 'Dokument auswählen…',
  'Select every visible row': 'Jede sichtbare Zeile auswählen',
  'selected': 'ausgewählt',
  'Set weight…': 'Gewicht setzen…',
  'Show all {n} revisions': 'Alle {n} Revisionen anzeigen',
  'Show every document': 'Alle Dokumente anzeigen',
  'Show latest 3': 'Die letzten 3 anzeigen',
  'Show the proposed': 'Die Vorgeschlagenen anzeigen',
  'Show the span {ref} cites in {doc}': 'Die Quellenstelle anzeigen, die {ref} in {doc} zitiert',
  'Show the span behind this question in {ref}': 'Die Quellenstelle hinter dieser Frage in {ref} anzeigen',
  'Show the uncited': 'Die Unbelegten anzeigen',
  'Show the unfunded': 'Die Unfinanzierten anzeigen',
  'signed — CR only': 'unterzeichnet — nur per Änderungsantrag',
  'Signed scope — every change goes through a change request.':
    'Unterzeichneter Umfang — jede Änderung geht durch einen Änderungsantrag.',
  'source': 'Quelle',
  'Source': 'Quelle',
  'Split…': 'Aufteilen…',
  'Split {ref}': '{ref} aufteilen',
  'Split into {n} — {ref} becomes out of scope': 'Aufteilen in {n} — {ref} geht aus dem Umfang',
  'stamped as': 'gestempelt als',
  'Statement': 'Aussage',
  'Status': 'Status',
  'Status of {ref}': 'Status von {ref}',
  'Steps': 'Schritte',
  'still draft': 'noch Entwurf',
  'superseded document': 'abgelöstes Dokument',
  'Tag {ref} with {tag}': '{ref} mit {tag} taggen',
  'Tag pool': 'Tag-Pool',
  'Tag pool — vocabulary editor': 'Tag-Pool — Vokabular-Editor',
  'Tag pool cleared — the agent proposes no tags': 'Tag-Pool geleert — der Agent schlägt keine Tags vor',
  'Tag pool saved — the agent may tag from it on its next run':
    'Tag-Pool gespeichert — der Agent darf beim nächsten Lauf daraus taggen',
  'Tags': 'Tags',
  'Tags are lowercase-kebab (letters/digits and single hyphens), 2–30 characters.':
    'Tags sind lowercase-kebab (Buchstaben/Ziffern und einzelne Bindestriche), 2–30 Zeichen.',
  'Test case': 'Testfall',
  'test cases': 'Testfälle',
  'Test cases': 'Testfälle',
  'Test data': 'Testdaten',
  'Test data reference': 'Testdaten-Referenz',
  'Test-case pass queued — the proposals land in the review queue':
    'Testfall-Durchgang eingereiht — die Vorschläge landen in der Warteschlange',
  'The {noun} is removed from the register for good.': '{noun} wird endgültig aus dem Register entfernt.',
  'The agenda is clear.': 'Die Agenda ist leer.',
  'the agent asks': 'der Agent fragt',
  'The agent reads settled questions as client decisions on its next run.':
    'Der Agent liest entschiedene Fragen beim nächsten Lauf als Kundenentscheidungen.',
  'the client call': 'das Kundengespräch',
  'The client-call agenda': 'Die Agenda des Kundengesprächs',
  'the coverage roll-up did not answer': 'die Abdeckungsauswertung hat nicht geantwortet',
  'The coverage roll-up did not answer — this is not a zero.':
    'Die Abdeckungsauswertung hat nicht geantwortet — das ist keine Null.',
  'The coverage roll-up did not answer, so this is not a clear verdict — it is the verdict on what answered.':
    'Die Abdeckungsauswertung hat nicht geantwortet — dies ist also kein klares Urteil, sondern das Urteil über das, was geantwortet hat.',
  'The ledger reports what it can count from those rows and marks the rest':
    'Die Bilanz berichtet, was sie aus diesen Zeilen zählen kann, und markiert den Rest',
  'The live app stores this link as proposal.target_requirement_id; a question logged FROM a conflict does not carry it, so the row is matched on the statement.':
    'Die Live-App speichert diese Verknüpfung als proposal.target_requirement_id; eine aus einem Konflikt protokollierte Frage trägt sie nicht, daher wird die Zeile über die Aussage zugeordnet.',
  'The milestone this deliverable is invoiced and accepted against':
    'Der Meilenstein, gegen den dieses Arbeitsergebnis fakturiert und abgenommen wird',
  'The obligation': 'Die Verpflichtung',
  'The only tags the agent may attach to its proposals — engagement-specific classification next to the (universal) category. Lowercase-kebab, 2–30 characters, at most 30 tags. Your own tag edits on requirements are not restricted to this pool.':
    'Die einzigen Tags, die der Agent an seine Vorschläge heften darf — auftragsspezifische Klassifizierung neben der (universellen) Kategorie. Lowercase-kebab, 2–30 Zeichen, höchstens 30 Tags. Ihre eigenen Tag-Änderungen an Anforderungen sind nicht auf diesen Pool beschränkt.',
  'The open questions did not load': 'Die offenen Fragen wurden nicht geladen',
  'The register did not answer': 'Das Register hat nicht geantwortet',
  'The register is empty.': 'Das Register ist leer.',
  'The requirement is kept with every revision and every piece of evidence — its status becomes':
    'Die Anforderung bleibt mit jeder Revision und jedem Beleg erhalten — ihr Status wird',
  'The roll-up said: “{error}”.': 'Die Auswertung meldete: «{error}».',
  'The rows': 'Die Zeilen',
  'The rows below are the register itself and are unaffected — they come from':
    'Die Zeilen unten sind das Register selbst und bleiben unberührt — sie stammen aus',
  'the search failed: “{error}”': 'die Suche schlug fehl: «{error}»',
  'The system shall …': 'Das System soll …',
  'The winning statement cannot be empty.': 'Die gewinnende Aussage darf nicht leer sein.',
  'then': 'dann',
  'This edits the VOCABULARY only — nothing here tags a requirement. To tag one, open its detail panel and click the pool chips there.':
    'Dies bearbeitet nur das VOKABULAR — nichts hier taggt eine Anforderung. Um eine zu taggen, öffnen Sie ihr Detail-Panel und klicken dort auf die Pool-Chips.',
  'This statement': 'Diese Aussage',
  'This writes': 'Dies schreibt',
  'Title': 'Titel',
  'Traceability CSV': 'Nachverfolgbarkeits-CSV',
  'Try again': 'Erneut versuchen',
  'Type': 'Typ',
  'Type of {ref}': 'Typ von {ref}',
  'uncategorised': 'ohne Kategorie',
  'unfunded — no deliverable carries it': 'nicht finanziert — kein Arbeitsergebnis trägt es',
  'unjustified': 'unbegründet',
  'Unjustified': 'Unbegründet',
  'unknown': 'unbekannt',
  'Unlink {ref}': 'Verknüpfung mit {ref} lösen',
  'unlinked': 'Verknüpfung gelöst',
  'Unsaved mapping changes — Save mapping applies them.':
    'Ungespeicherte Zuordnungsänderungen — «Zuordnung speichern» wendet sie an.',
  'View in context →': 'Im Kontext ansehen →',
  'Weight': 'Gewicht',
  'Weight of {ref}': 'Gewicht von {ref}',
  'What must be true for this to count as delivered.': 'Was wahr sein muss, damit dies als geliefert gilt.',
  'What the contract says is NOT included — first-class scope, not an absence':
    'Was der Vertrag als NICHT enthalten bezeichnet — vollwertiger Umfang, kein Fehlen',
  'what the next gate still wants from this register — one clause, then the rest':
    'was das nächste Gate von diesem Register noch will — eine Klausel, dann der Rest',
  'Why this exists — the business reason, not the implementation.':
    'Warum es dies gibt — der geschäftliche Grund, nicht die Umsetzung.',
  'Will be deleted': 'Wird gelöscht',
  'without a milestone': 'ohne Meilenstein',
  'Write a test case against these criteria': 'Einen Testfall gegen diese Kriterien schreiben',
  'Write it to {ref}': 'In {ref} schreiben',
  'Write one by hand': 'Eine von Hand schreiben',
  'Writes': 'Schreibt',

  // ── plurals (both forms are keys) ──
  '{n} acceptance criterion': '{n} Abnahmekriterium',
  '{n} acceptance criteria': '{n} Abnahmekriterien',
  '{n} call — bulk takes tags as a replacement set, so one per resulting tag set':
    '{n} Aufruf — Bulk nimmt Tags als Ersatzmenge, also einer pro resultierender Tag-Menge',
  '{n} calls — bulk takes tags as a replacement set, so one per resulting tag set':
    '{n} Aufrufe — Bulk nimmt Tags als Ersatzmenge, also einer pro resultierender Tag-Menge',
  '{n} condition is not on this ladder at all — {list} needs the coverage roll-up, and it did not answer.':
    '{n} Bedingung steht gar nicht auf dieser Leiter — {list} braucht die Abdeckungsauswertung, und sie hat nicht geantwortet.',
  '{n} conditions are not on this ladder at all — {list} need the coverage roll-up, and it did not answer.':
    '{n} Bedingungen stehen gar nicht auf dieser Leiter — {list} brauchen die Abdeckungsauswertung, und sie hat nicht geantwortet.',
  '{n} criterion': '{n} Kriterium',
  '{n} criteria': '{n} Kriterien',
  '{n} criterion held — an operator now stands behind it': '{n} Kriterium übernommen — ein Operator steht jetzt dahinter',
  '{n} criteria held — an operator now stands behind them': '{n} Kriterien übernommen — ein Operator steht jetzt dahinter',
  '{n} criterion with no test case': '{n} Kriterium ohne Testfall',
  '{n} criteria with no test case': '{n} Kriterien ohne Testfall',
  '{n} deliverable': '{n} Arbeitsergebnis',
  '{n} deliverables': '{n} Arbeitsergebnisse',
  '{n} evidence span rejected — a quote must be a literal substring of the cited document. Fix the marked rows and submit again; nothing was saved.':
    '{n} Quellenstelle abgelehnt — ein Zitat muss eine wörtliche Teilzeichenkette des zitierten Dokuments sein. Korrigieren Sie die markierten Zeilen und senden Sie erneut; nichts wurde gespeichert.',
  '{n} evidence spans rejected — a quote must be a literal substring of the cited document. Fix the marked rows and submit again; nothing was saved.':
    '{n} Quellenstellen abgelehnt — ein Zitat muss eine wörtliche Teilzeichenkette des zitierten Dokuments sein. Korrigieren Sie die markierten Zeilen und senden Sie erneut; nichts wurde gespeichert.',
  '{n} evidence span rejected — see the marked rows. Nothing was saved.':
    '{n} Quellenstelle abgelehnt — siehe die markierten Zeilen. Nichts wurde gespeichert.',
  '{n} evidence spans rejected — see the marked rows. Nothing was saved.':
    '{n} Quellenstellen abgelehnt — siehe die markierten Zeilen. Nichts wurde gespeichert.',
  '{n} exclusion': '{n} Ausschluss',
  '{n} exclusions': '{n} Ausschlüsse',
  '{n} requirement': '{n} Anforderung',
  '{n} requirements': '{n} Anforderungen',
  '{n} requirement deleted': '{n} Anforderung gelöscht',
  '{n} requirements deleted': '{n} Anforderungen gelöscht',
  '{n} requirement mapped to {ref}': '{n} Anforderung {ref} zugeordnet',
  '{n} requirements mapped to {ref}': '{n} Anforderungen {ref} zugeordnet',
  '{n} requirement updated': '{n} Anforderung aktualisiert',
  '{n} requirements updated': '{n} Anforderungen aktualisiert',
  '{n} revision': '{n} Revision',
  '{n} revisions': '{n} Revisionen',
  '{n} row tagged {tag}{already} · {cost}': '{n} Zeile mit {tag} getaggt{already} · {cost}',
  '{n} rows tagged {tag}{already} · {cost}': '{n} Zeilen mit {tag} getaggt{already} · {cost}',
  '{n} statement matched “{q}” on the server (trigram + ILIKE over current revisions)':
    '{n} Aussage entsprach «{q}» auf dem Server (Trigram + ILIKE über aktuelle Revisionen)',
  '{n} statements matched “{q}” on the server (trigram + ILIKE over current revisions)':
    '{n} Aussagen entsprachen «{q}» auf dem Server (Trigram + ILIKE über aktuelle Revisionen)',
  '{n} test case': '{n} Testfall',
  '{n} test cases': '{n} Testfälle',
  '{n} test case now {status}': '{n} Testfall jetzt {status}',
  '{n} test cases now {status}': '{n} Testfälle jetzt {status}',
  '{ref} maps {n} requirement': '{ref} ordnet {n} Anforderung zu',
  '{ref} maps {n} requirements': '{ref} ordnet {n} Anforderungen zu',
  'Back to proposed ◇ — {n} row': 'Zurück zu vorgeschlagen ◇ — {n} Zeile',
  'Back to proposed ◇ — {n} rows': 'Zurück zu vorgeschlagen ◇ — {n} Zeilen',
  'Delete {n} requirement?': '{n} Anforderung löschen?',
  'Delete {n} requirements?': '{n} Anforderungen löschen?',
  'Delete {n} row permanently…': '{n} Zeile endgültig löschen…',
  'Delete {n} rows permanently…': '{n} Zeilen endgültig löschen…',
  'Propose test cases for {n} criterion': 'Testfälle für {n} Kriterium vorschlagen',
  'Propose test cases for {n} criteria': 'Testfälle für {n} Kriterien vorschlagen',
  'Run extraction on {n} ready document': 'Extraktion auf {n} bereitem Dokument ausführen',
  'Run extraction on {n} ready documents': 'Extraktion auf {n} bereiten Dokumenten ausführen',
  'selected row is no longer in this engagement and was left alone.':
    'ausgewählte Zeile ist nicht mehr in diesem Auftrag und wurde nicht angerührt.',
  'selected rows are no longer in this engagement and were left alone.':
    'ausgewählte Zeilen sind nicht mehr in diesem Auftrag und wurden nicht angerührt.',
  // ── THE PENCIL LAYER on the client call ──
  'Adopt the {n} assumption pencilled against this question': 'Die {n} Annahme übernehmen, die an dieser Frage hängt',
  'Adopt the {n} assumptions pencilled against this question': 'Die {n} Annahmen übernehmen, die an dieser Frage hängen',
  '{n} assumption adopted': '{n} Annahme übernommen',
  '{n} assumptions adopted': '{n} Annahmen übernommen',
  '{n} assumption reverted': '{n} Annahme verworfen',
  '{n} assumptions reverted': '{n} Annahmen verworfen',
  '{n} date is pencilled against this question — confirming or refusing rubs it out':
    '{n} Termin ist an dieser Frage geplant — Bestätigen oder Ablehnen verwirft ihn',
  '{n} dates are pencilled against this question — confirming or refusing rubs them out':
    '{n} Termine sind an dieser Frage geplant — Bestätigen oder Ablehnen verwirft sie',

  // ── the compose overlay's overview rail, the editable detail modal, the REQ hover ──
  'not funded yet': 'noch nicht finanziert',
  'already funded by': 'bereits finanziert durch',
  'No deliverable covers this yet (G2)': 'Noch kein Arbeitsergebnis deckt dies ab (G2)',
  '{ref} renamed': '{ref} umbenannt',
  '{ref} description saved': '{ref} Beschreibung gespeichert',
  '{ref} definition of done saved': '{ref} Abnahmekriterien gespeichert',
  // ── the reference system: the # picker, who-names-this, the dangle warning ──
  '# inserts a reference — DEL-xx, REQ-xxx': '# fügt eine Referenz ein — DEL-xx, REQ-xxx',
  'Referenced in': 'Referenziert in',
  'texts that name {ref} — change it and they may need to move along': 'Texte, die {ref} nennen — ändern Sie es, müssen sie eventuell mitziehen',
  '{n} text elsewhere names {ref} — it stays, and the name will dangle. Update it afterwards.':
    '{n} Text an anderer Stelle nennt {ref} — er bleibt, und der Name hängt dann in der Luft. Aktualisieren Sie ihn danach.',
  '{n} texts elsewhere name {ref} — they stay, and the name will dangle. Update them afterwards.':
    '{n} Texte an anderer Stelle nennen {ref} — sie bleiben, und der Name hängt dann in der Luft. Aktualisieren Sie sie danach.',
  '{n} text keeps naming it — update after': '{n} Text nennt es weiterhin — danach aktualisieren',
  '{n} texts keep naming it — update after': '{n} Texte nennen es weiterhin — danach aktualisieren',
  'ref must be a register ref like DEL-02 or REQ-014.': 'ref muss eine Register-Referenz wie DEL-02 oder REQ-014 sein.',
}, 'RegisterPage');
